import { useConflitosAlocacaoDialog } from "./use-conflitos-alocacao-dialog";
import { ConflitosAlocacaoDialogView } from "./view-conflitos-alocacao-dialog";
import type { ConflitosAlocacaoDialogProps } from "./types-conflitos-alocacao-dialog";

export function ConflitosAlocacaoDialog(props: ConflitosAlocacaoDialogProps) {
  const vm = useConflitosAlocacaoDialog(props);

  return <ConflitosAlocacaoDialogView {...props} {...vm} />;
}

export type * from "./types-conflitos-alocacao-dialog";
